import type { SelectableColumn } from "@/hooks/use-column-selection";
import { useOpportunityColumnSelection } from "@/hooks/use-column-selection";
import { getOpportunityColumns } from "@/pages/opportunities/opportunity-list/opportunity-columns";
import { EntityColumnSelector } from "./entity-column-selector";

interface OpportunityColumnSelectorProps {
  // Optional: provide column state externally (for DRR integration)
  columnState?: {
    availableColumns: SelectableColumn[];
    isColumnSelected: (columnId: string) => boolean;
    toggleColumn: (columnId: string) => void;
    isLoading?: boolean;
    error?: Error | null;
  };
}

/**
 * Component for managing opportunity column selection including both core and custom fields.
 * Displays a popover with checkboxes for selecting which columns to display.
 * Can accept external column state for DRR integration, or use its own hooks.
 */
export function OpportunityColumnSelector({
  columnState,
}: OpportunityColumnSelectorProps = {}) {
  const coreColumns = getOpportunityColumns({});

  // Use provided state OR internal hook
  const internalState = useOpportunityColumnSelection(
    columnState ? [] : coreColumns,
  );
  const { availableColumns, isColumnSelected, toggleColumn, isLoading, error } =
    columnState || internalState;

  return (
    <EntityColumnSelector
      availableColumns={availableColumns}
      isColumnSelected={isColumnSelected}
      toggleColumn={toggleColumn}
      isLoading={isLoading || false}
      error={error || null}
      buttonLabel="Columns"
      noColumnsMessage="No columns available."
      errorMessage="Error loading columns."
    />
  );
}
